(() => {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('loading')) return;
    btn.classList.add('loading');

    const variantId = btn.dataset.variantId;
    const cartDrawer = document.querySelector('cart-drawer');
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        const sections = cartDrawer.getSectionsToRender().map((s) => s.section);
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname);
      } catch (err) {
        console.warn('quick-add sections lookup failed', err);
      }
    }

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const json = await response.json();
      if (json.status) {
        console.warn('quick-add error', json);
        return;
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(json);
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (err) {
      console.error('quick-add failed', err);
    } finally {
      btn.classList.remove('loading');
    }
  });
})();
